import { getLocale } from "../runtime";

const sv_chooselangall = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Välj språk / Choose language`
};

const chooselangall = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_chooselangall(inputs)
	return "chooseLangAll";
};

export { chooselangall as "chooseLangAll" };